import React, { useEffect, useState } from 'react';
import './App.css';
import ContentContainer from './Components/ContentContainer/ContentContainer'
import { Route, Switch, useHistory } from 'react-router-dom'
import RouterChooser from './Components/RouterChooser/RouterChooser'
import { useApolloClient } from "@apollo/client";
import { SETTINGS_QUERY } from './Components/Profile/Components/SettingsSection/Queries/SettingsQueries'
import { connect } from 'react-redux'
import { setSettings } from '../actions/settings'
import { logOut } from "../actions/session";
import HomeWrapper from "./Components/HomeWrapper/HomeWrapper";
import pkg from "../../../package.json"
import isElectron from "is-electron";
import { setIntervalAndExecute, setLastLogin } from "../../web/Utils/utils";
import { LAST_LOGIN_INTERVAL } from "./Constants/AppData";
import Loader from "./Components/Loader/Loader";
import { Black, Shadow, WerfenColor } from "./Constants/ColorChart";
import styled from "styled-components";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import { initFetchInterceptor } from '../utils/fetchInterceptor';

/*
 *  @Description:   Entry point of the App.
 */


const StyledDiv = styled.div`
  margin-top: 110px;
  width: 100%;
  margin-left: auto;
  margin-right:auto;
  @media (min-width: 765px){
      margin-top: 150px;
  }
`;

//Implementation of entries method for Object class. IE11 doesn't have such implementation.
const setObjectEntries = () => {
    if ( !Object.entries )
        Object.entries = function ( obj ) {
            let ownProps = Object.keys ( obj ),
                i = ownProps.length,
                resArray = new Array ( i ); // preallocate the Array

            while ( i-- )
                resArray[i] = [ ownProps[i], obj[ownProps[i]] ];

            return resArray;
        };
}

const App = ( props ) => {
    const [ settingsAreSet, setSettingsAreSet ] = useState ( false );
    const [ tokenIsSet, setTokenIsSet ] = useState ( false );
    const client = useApolloClient ();
    const history = useHistory ();
    const { pushInstruction } = useMatomo ();
    useEffect ( () => {
            // Initialize the fetch interceptor when the app loads
        initFetchInterceptor(client, props.logOut);

        setObjectEntries ();
        if ( props.isNetworkAvailable /*&& props.isServerReachable */ ) {
            client
                .query ( { query: SETTINGS_QUERY, options: { 'errorPolicy': 'ignore' } } )
                .then ( ( response ) => {
                    // console.info("'settings query' receives 'response': ", response.data.currentUserSettings[0])
                    setSettings ( response.data.currentUserSettings[0] )
                    if ( response.error ) {
                        console.error ( "the error in the response is ", response.error )
                    } else {
                        if ( isElectron () ) {
                            setIntervalAndExecute ( setLastLogin, LAST_LOGIN_INTERVAL )
                            // setLastLogin();
                        }
                    }
                } )
                .catch ( ( error ) => {
                    console.error("Error: ", error);
                    if(!isElectron()){
                        props.logOut ();
                    }
                    history.push ( "/" )
                } );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    useEffect ( () => {
        setTokenIsSet ( true );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ props.session.token ] );


    const setSettings = ( settings ) => {
        console.log('settings', settings);
        const data = {
            playlistsFirst: settings.showPlaylistFirst,
            expandedByDefault: settings.expandDescriptionsByDefault,
            syncDownloads: settings.syncOnStartup,
            preferredLanguage: settings.preferredLanguage,
            preferredFileFormat: settings.defaultDocumentExtension,
            businessUnits: JSON.parse ( settings.businessUnits ),
            departments: JSON.parse ( settings.departments ),
            fileExtensions: ['PDF', 'DOCX', 'XLSX', 'ZIP'],
            types: ['Playlist', 'Resource'],
            dates: ['last_week', 'last_month', 'last_year'],
            datesMap: {
                last_week: 'Last 7 days',
                last_month: 'Last 30 days',
                last_year: 'Last 12 months',
            },
            salesOrganizations: JSON.parse ( settings.salesOrganizations ),
        };

        props.setSettings ( data );
        const businessUnitsIds = data.businessUnits.map ( ( businessUnit ) => businessUnit.value ).toString();
        const departmentsIds = data.departments.map ( ( department ) => department.value ).toString();

        localStorage.setItem('departments', departmentsIds);
        localStorage.setItem('businessUnits', businessUnitsIds);

        setSettingsAreSet ( true );

        pushInstruction ( 'setUserId', props.session.user );
        pushInstruction ( 'setCustomUrl', isElectron () ? process.env.REACT_APP_SITE_URL + window.location.pathname : window.location.href );
        pushInstruction ( 'setCustomVariable', 1, "Sales Organization", JSON.parse ( settings.salesOrganizations )[0], "visit" );
        pushInstruction ( 'setCustomVariable', 2, "App Version", pkg.version, "visit" );
        pushInstruction ( 'trackPageView' );
    }

    return (
        <>
            {
                ( (!isElectron() && !settingsAreSet) || !tokenIsSet ) &&
                <StyledDiv>
                    <Loader
                        message="Logging in..."
                        primaryColor={ WerfenColor }
                        secondaryColor={ Shadow }
                        fontColor={ Black }
                        extraStyle="margin-top: 10%; width: 150px;"
                    />
                </StyledDiv>
            }
            {
                (settingsAreSet || isElectron()) &&
                tokenIsSet &&
                <RouterChooser>
                    <Switch>
                        <Route exact path='/'
                               render={ () => <HomeWrapper/> }/>
                        <Route path='/*' render={ () => <ContentContainer/> }/>
                    </Switch>
                </RouterChooser>
            }
        </>
    );

}

const mapStateToProps = ( state ) => ( {
    isNetworkAvailable: state.sensors.isNetworkAvailable,
    isServerReachable: state.sensors.isServerReachable,
    session: state.session,
} )

export default connect ( mapStateToProps, { setSettings, logOut } ) ( App );
